import { render, staticRenderFns } from "./WeeklyView.vue?vue&type=template&id=6c5070d1"
import script from "./WeeklyView.vue?vue&type=script&lang=js"
export * from "./WeeklyView.vue?vue&type=script&lang=js"
import style0 from "./WeeklyView.vue?vue&type=style&index=0&id=6c5070d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports